"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bootstrap_1 = require("bootstrap");
const bootstrap_2 = require("bootstrap");
var throttle = require('lodash.throttle');
const player_1 = __importDefault(require("@vimeo/player"));
const rellax_1 = __importDefault(require("rellax"));
const form_1 = require("./form");
// init form
(0, form_1.formInit)();
function escapeHtml(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
// only allow http(s), mailto and relative links in citation hrefs
function safeHref(href) {
    if (!href)
        return '#';
    const url = new URL(href, location.href);
    return ['http:', 'https:', 'mailto:'].includes(url.protocol) ? url.href : '#';
}
let content = document.getElementById('content');
const contentClass = content === null || content === void 0 ? void 0 : content.classList;
let theme;
if (contentClass && contentClass[0] != 'container-xl') {
    theme = contentClass[0];
}
else {
    theme = 'gold';
}
const dots_1 = require("./dots");
let dots = new dots_1.Dots({
    length: 5,
    elementSelector: '.portal-dots'
});
let menuTriggers = document.getElementsByClassName('modal-menu');
let activeModal;
let canvas = bootstrap_2.Offcanvas;
const scrollreveal_1 = __importDefault(require("scrollreveal"));
//Scroll Reveal animation
(0, scrollreveal_1.default)().reveal('.reveal-y', {
    //interval: 250,
    //delay: 500,
    distance: '50px',
    afterReveal: function (el) {
        el.style.transition = '';
        el.style.transform = '';
    }
});
(0, scrollreveal_1.default)().reveal('.reveal', {
    interval: 375,
    delay: 250,
    viewFactor: 0.25,
    afterReveal: function (el) {
        el.classList.add('is-visible');
    }
});
// our technology scroll reveal 
(0, scrollreveal_1.default)().reveal('.reveal-portal', {
    interval: 750,
    delay: 500,
    viewFactor: 0.25,
    reset: true,
    afterReveal: onReveal,
    afterReset: onReset
});
function onReveal(el) {
    //console.log(el,'el reveal')
    el.classList.add('is-visible');
    setPlayers(el, 'play');
}
function onReset(el) {
    // console.log(el,'el reset')
    el.classList.remove('is-visible');
    setPlayers(el, 'pause');
}
function setPlayers(el, action) {
    // console.log('set players el',el)
    const parent = el.closest('.portal-strip');
    let player1;
    let player2;
    let player3;
    //set players
    if (parent) {
        switch (parent.id) {
            case 'family-wealth':
                player1 = players[0];
                break;
            case 'wealth-growth':
                player1 = players[1];
                player2 = players[2];
                break;
            case 'important-documents':
                player1 = players[3];
                player2 = players[4];
                break;
            case 'investments':
                player1 = players[5];
                player2 = players[6];
                player3 = players[7];
                break;
            default:
                //transactions
                player1 = players[8];
                player2 = players[9];
                break;
        }
    }
    if (player1) {
        const player1Playing = player1.currentTime > 0 && !player1.paused && !player1.ended
            && player1.readyState > player1.HAVE_CURRENT_DATA;
        if (action == 'play') {
            player1.play();
        }
        else {
            player1.pause();
            player1.setCurrentTime(0);
        }
    }
    if (player2) {
        const player2Playing = player2.currentTime > 0 && !player2.paused && !player2.ended
            && player2.readyState > player2.HAVE_CURRENT_DATA;
        if (action == 'play') {
            player2.play();
        }
        else {
            player2.pause();
            player2.setCurrentTime(0);
        }
    }
    if (player3) {
        const player3Playing = player3.currentTime > 0 && !player3.paused && !player3.ended
            && player3.readyState > player3.HAVE_CURRENT_DATA;
        if (action == 'play') {
            player3.play();
        }
        else {
            player3.pause();
            player3.setCurrentTime(0);
        }
    }
}
// our technology scroll reveal ends
// our technology page logic
//create array of page players
const portalVideos = document.querySelectorAll('.portal-strip iframe');
const players = new Array();
//console.log(players,'players')
if (portalVideos.length > 0) {
    Array.from(portalVideos).forEach((el, index) => {
        const element = el;
        //console.log(el.id, 'iframe id')
        const player = new player_1.default(element);
        players.push(player);
    });
}
// Define our viewportWidth variable
let viewportWidth;
// Set/update the viewportWidth value
const setViewportWidth = function () {
    viewportWidth = window.innerWidth || document.documentElement.clientWidth;
};
const rellaxEl = document.querySelectorAll('.rellax');
// Log the viewport width into the console
const setRellax = function () {
    if (viewportWidth > 768 && rellaxEl.length > 0) {
        //console.log('Wide viewport');
        const rellax = new rellax_1.default('.rellax', {
            center: true
            // wrapper:'.portal-strip'
        });
    }
};
// Set our initial width and log it
setViewportWidth();
setRellax();
// On resize events, recalculate and log
window.addEventListener('resize', function () {
    setViewportWidth();
    setRellax();
}, false);
// Portal - highlighted text on scroll
//console.log('foo bar 12')
const siblings = (elem) => {
    // create an empty array
    let siblings = [];
    // if no parent, return empty list
    if (!elem.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling = elem.parentNode.firstElementChild;
    // loop through next siblings until `null`
    do {
        // push sibling to array
        if (sibling != elem) {
            siblings.push(sibling);
        }
    } while (sibling = sibling.nextElementSibling);
    return siblings;
};
window.addEventListener('scroll', throttle(() => {
    // portal highlight text
    let gridTop;
    const windowHeight = window.innerHeight, gridBottom = windowHeight, highlights = document.querySelectorAll('.portal-highlight-text li');
    if (viewportWidth < 1070 && viewportWidth > 767) {
        gridTop = windowHeight * .5;
    }
    if (viewportWidth < 768) {
        gridTop = windowHeight * .5;
    }
    else {
        gridTop = windowHeight * .7;
    }
    //console.log(highlights,'highlights')
    for (var i = 0; i < highlights.length; i++) {
        //console.log(highlights[i]);
        const item = highlights[i];
        const thisTop = window.scrollY - item.offsetTop;
        // console.log(thisTop,'this top')
        // console.log(gridTop,'grid top')
        // console.log(gridBottom,'grid bottom')
        if (thisTop > gridTop && thisTop < gridBottom) {
            const nodes = siblings(item);
            nodes.forEach(function (value) {
                value.classList.remove("opacity-1");
            });
            item.classList.add('opacity-1');
        }
        else {
            item.classList.remove('opacity-1');
        }
    }
}));
Array.from(menuTriggers).forEach(el => {
    let element = el;
    el.addEventListener('click', function (event) {
        event.preventDefault();
        // hide currently active modal
        if (activeModal)
            activeModal.hide();
        // trigger x transition
        document.body.classList.add('modal-menu-open');
        // add modal active state to the nav
        Array.from(document.getElementsByClassName('modal-active')).forEach(element => {
            element.classList.remove('modal-active');
        });
        element.classList.add('modal-active');
        if (element.dataset.bsTarget) {
            let modalElement = document.getElementById(element.dataset.bsTarget);
            if (modalElement) {
                let modal = bootstrap_1.Modal.getOrCreateInstance(modalElement);
                modal.show();
                activeModal = modal;
                // show back arrow on mobile if a submenu, and add the title
                let mobileHeader = document.getElementById('mobile-header');
                let mobileHeaderTitle = document.getElementById('mobile-header-title');
                if (mobileHeader && mobileHeaderTitle) {
                    if (element.dataset.bsTarget != 'mobile-nav') {
                        mobileHeader.classList.add('active');
                        mobileHeaderTitle.textContent = element.textContent;
                    }
                    else {
                        mobileHeader.classList.remove('active');
                        mobileHeaderTitle.textContent = '';
                    }
                }
            }
        }
    });
});
// Select dropdown for blog categories, mobile only
const categorySelect = document.querySelector(`[id="categorySelect"]`);
if (categorySelect) {
    categorySelect.addEventListener('change', (e) => {
        const target = e.target;
        // only follow same-site links, never javascript: or external URLs
        const url = new URL(target.value, location.origin);
        if (url.origin === location.origin) {
            location.href = url.href;
        }
    });
    const option = categorySelect.querySelector(`[value="${location.pathname}"]`);
    if (option) {
        option.selected = true;
    }
}
//citations toggle
let cardToggle = document.querySelectorAll('.citations-toggle');
if (cardToggle.length > 0) {
    cardToggle[0].addEventListener('click', function (event) {
        event.preventDefault();
        const evtTarget = event.target;
        const target = evtTarget.dataset.target;
        const btn = evtTarget.dataset.btn;
        const elTarget = document.getElementsByClassName(target);
        const elBtn = document.getElementsByClassName(btn);
        elTarget[0].classList.toggle("active");
        elBtn[0].classList.toggle("active");
    });
}
//citation box and tooltip builder
let citations = document.querySelectorAll('.eat-citation');
//console.log(citations,'citations');
if (citations.length > 0) {
    let citationsInner = document.querySelectorAll('.citations-box .citations-inner');
    const list = document.createElement("ul");
    list.classList.add('mt-5', 'list-unstyled', 'citations-list');
    citationsInner[0].prepend(list);
    const schemaArray = [];
    Array.from(citations).forEach((el, index) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
        });
        const href = safeHref(el.getAttribute('href'));
        const text = el.innerHTML;
        const title = el.getAttribute('title') || '';
        el.setAttribute('title', '');
        el.setAttribute('data-bs-toggle', 'tooltip');
        el.setAttribute('data-bs-trigger', "click");
        el.setAttribute('data-bs-placement', "bottom");
        // build the list item with DOM APIs so title/href can't inject markup
        const listItem = document.createElement("li");
        listItem.classList.add('mb-3');
        el.childNodes.forEach(node => listItem.appendChild(node.cloneNode(true)));
        listItem.append(' ');
        if (el.classList.contains('eat-nolink')) {
            el.setAttribute('data-bs-title', text + " " + title);
            listItem.append(title);
        }
        else {
            el.setAttribute('data-bs-title', text + " <a href='" + escapeHtml(href) + "' class='tooltip-" + theme + "' target='_blank'>" + escapeHtml(title) + "</a>");
            el.setAttribute('data-bs-html', "true");
            const link = document.createElement('a');
            link.href = href;
            link.target = '_blank';
            link.textContent = title;
            listItem.appendChild(link);
        }
        list.appendChild(listItem);
        //push citation to schema
        //schemaArray.push(title);
    });
    // const saltusArticle0 = saltusArticle[0];
    // //get schema inner HTML
    // const saltusArticleObj = JSON.parse(saltusArticle0.innerHTML);
    // //add citations
    // saltusArticleObj.citations = schemaArray;
    // saltusArticle0.innerHTML = JSON.stringify(saltusArticleObj);
    let citationsBox = document.querySelectorAll('.citations-box');
    citationsBox[0].classList.remove('d-none');
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap_1.Tooltip(tooltipTriggerEl));
    //console.log(tooltipTriggerList,'trigger list');
}
//add heading line
document.querySelectorAll('.blog .h4, .blog h4, .blog h2, .wealth-index-text h4, .wi-landing .wealth-index-text h3, .wealth-index-sticky h5, .video-template h4, .video-template h3, .video-template h2').forEach((el) => {
    el.insertAdjacentHTML("beforeend", "<span class=\"border-b border border-primary w-30 my-4 d-block\"></span>");
});
// Bootstrap Scrollspy
const navScroll = document.getElementsByClassName('navbar-scroll');
if (navScroll) {
    let scrollSpy = new bootstrap_1.ScrollSpy(document.body, {
        target: '.navbar-scroll'
    });
    // console.log(scrollSpy);
    // console.log('scrollspy!')
}
//sticky menu and header 
let aauSticky = document.querySelector('.header-sticky-aau-mobile .accordion-collapse');
const stickyLinks = document.querySelectorAll('.header-sticky-aau-mobile .nav-link');
Array.from(stickyLinks).forEach(element => {
    element.addEventListener('click', () => {
        const collapsedAauSticky = bootstrap_1.Collapse.getInstance(aauSticky);
        if (collapsedAauSticky) {
            collapsedAauSticky.hide();
        }
    });
});
let wiSticky = document.querySelector('.wealth-index-sticky .accordion-collapse');
const wiStickyLinks = document.querySelectorAll('.wealth-index-sticky .nav-item');
Array.from(wiStickyLinks).forEach(element => {
    element.addEventListener('click', (el) => {
        const wiStickyCollapse = bootstrap_1.Collapse.getOrCreateInstance(wiSticky);
        if (wiStickyCollapse) {
            wiStickyCollapse.hide();
        }
    });
});
//sticky header
let stickyHeader = document.getElementById('header-sticky');
window.addEventListener('scroll', throttle(() => {
    if (stickyHeader) {
        if (window.scrollY > 216) {
            stickyHeader.classList.add('header-sticky-show');
            stickyHeader.classList.remove('header-sticky-hide');
        }
        else {
            stickyHeader.classList.add('header-sticky-hide');
            stickyHeader.classList.remove('header-sticky-show');
        }
        stickyHeight();
    }
}, 100));
function stickyHeight() {
    const header = document.querySelectorAll('header');
    const main = document.querySelectorAll('main > .container-xl');
    let viewportHeight = window.innerHeight + 20;
    let stickyEl;
    const stickyNav = document.querySelector('nav.wi-landing-sticky');
    if (stickyNav) {
        stickyEl = stickyNav;
    }
    else {
        stickyEl = stickyHeader;
    }
    if (stickyEl) {
        const navSticky = document.querySelectorAll('nav.wealth-index-sticky');
        Array.from(navSticky).forEach((el, index) => {
            const remainHeight = header[0].clientHeight + stickyEl.clientHeight;
            let dif;
            if (main.length > 0) {
                dif = main[0].clientHeight - remainHeight;
            }
            else {
                dif = remainHeight;
            }
            const element = el;
            if (window.scrollY > 211 && window.scrollY < dif) {
                element.style.height = viewportHeight - remainHeight + 'px';
            }
            else {
                element.style.height = 'auto';
            }
        });
    }
}
//capture anchor hrefs and add url before for routing
const hrefs = document.querySelectorAll("a");
Array.from(hrefs).forEach((el, index) => {
    const href = el.getAttribute("href");
    if ((href === null || href === void 0 ? void 0 : href.charAt(0)) === "#") {
        el.setAttribute('href', window.location.pathname + href);
    }
});
